import React from "react";
import { observer } from "mobx-react";
import aiAgentStore from "Stores/AIAgentStore";
import MessageBridge, { MessageTypes } from "Utils/MessageBridge";
import "./AIAgent.scss";

const AIAgentToggle = observer(() => {
  const { isOpen } = aiAgentStore; // Visual state might be stale if store not synced, but acceptable for MVP

  const handleClick = () => {
    MessageBridge.sendToShell(MessageTypes.TOGGLE_AI_PANEL);
  };

  return (
    <div 
      className={`aiAgentToggle ${isOpen ? "active" : ""}`} 
      onClick={handleClick}
      title="Toggle AI Agent"
    >
      <span className="material-symbols-outlined toggleIcon">side_navigation</span>
    </div>
  );
});

export default AIAgentToggle;
